import { ReactNode } from "react";
import { KebabMenu, MenuItemDef } from "../KebabMenu";
import s from "./PageHead.module.scss";

/** One primary action per page; at most two secondary; everything rarer under ⋯. */
/** `meta` (e.g. a count pill) sits beside the heading, outside it, so the heading's name stays the title alone. */
/**
 * `menuNode` is a page's own ⋯ (its own menu and dialogs) instead of `menu`: after the actions on desktop,
 * beside the title on a phone (where the actions take a full row).
 * A `menu` with no action beside it (a phone with only the floating add button) goes in that same slot, so the ⋯ sits
 * at the end of the title row and not alone on a row of its own.
 */
export const PageHead = ({ title, meta, subtitle, primary, secondary, menu, menuNode }:
  { title: ReactNode; meta?: ReactNode; subtitle?: ReactNode; primary?: ReactNode; secondary?: ReactNode; menu?: MenuItemDef[]; menuNode?: ReactNode }) => {
  const alone = !primary && !secondary && !menuNode && !!menu?.length;
  const slot = menuNode ?? (alone ? <KebabMenu items={menu!} /> : null);
  return (
  <header className={s.head}>
    <div className={s.titles}>
      {meta ? <div className={s.titleRow}><h1 className={s.title}>{title}</h1>{meta}</div> : <h1 className={s.title}>{title}</h1>}
      {subtitle && <p className={s.subtitle}>{subtitle}</p>}
    </div>
    {(primary || secondary || (!alone && menu?.length)) && (
      <div className={s.actions}>
        {!alone && menu && menu.length > 0 && <KebabMenu items={menu} />}
        {secondary}
        {primary}
      </div>
    )}
    {slot && <div className={s.menuSlot}>{slot}</div>}
  </header>
  );
};
